@if (lesson() !== undefined) {
  <div role="region"
       aria-labelledby="td-wb-aria-lesson-title-header">
    <ng-container *ngTemplateOutlet="playerTemplate" />
    <td-wb-tabs class="td-wb-learn-player__tabs"
                [selectedTabId]="selectedTab"
                (selectedTabIdChange)="setActiveTab($event)">
      <td-wb-tab tabId="overview">
        <span translate="tdWb.learn.player.tabs.OVERVIEW"></span>
      </td-wb-tab>
      <td-wb-tab tabId="transcript">
        <span translate="tdWb.learn.player.tabs.TRANSCRIPT"></span>
      </td-wb-tab>
    </td-wb-tabs>
    @if (selectedTab === 'overview') {
      <div class="td-wb-learn-player__title-container">
        @if (!lessonView()) {
          <div class="td-wb-learn-player__title-container-inner">
            @if (lesson().title !== undefined) {
              <h2 class="td-wb-learn-player__title">
                <span translate="tdWb.learn.player.LESSON_TITLE"
                      [translateParams]="{lessonNumber: lesson().lessonNumber}"></span>
                <span id="td-wb-aria-lesson-title-header"
                      [innerText]="lesson().title"></span>
              </h2>
            }
          </div>
          <td-wb-learn-lesson-info [lesson]="lesson()"
                                   [hideFilters]="hideFilters()" />
        }
        <div class="td-wb-learn-player__description">
          @if (lesson().description !== undefined) {
            <span [innerText]="lesson().description"></span>
          }
        </div>
      </div>
    }
    <!-- Transcript -->
    @if (selectedTab === 'transcript') {
      <div class="td-wb-learn-player__transcript">
        @if (lesson().textTrack !== undefined) {
          <span tdWbScrollable
                [innerText]="lesson().textTrack"></span>
        } @else {
          <span translate="tdWb.learn.player.NO_TRANSCRIPT"></span>
        }
      </div>
    }
  </div>
}


<ng-template #playerTemplate>
  <td-wb-brightcove-player
    tdWbDataAnalyticsTagging
    [eventSignal]="eventData"
    [videoId]="lesson().contentMetaData.id"
    [autoPlay]="autoPlay()"
    [currentTime]="progress"
    [section]="section()"
    [timeupdateEnabled]="timeupdateEnabled"
    (timeupdateChange)="timeupdate($event)"
    (cueChange)="onCueChange($event)"
    (pausedChange)="onPausedChange($event)">
    <ng-content />
  </td-wb-brightcove-player>
</ng-template>
